var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuggestedMeditationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2378_6625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 17.0834L30 22.0834L30 29.5834C30 30.25 29.7431 30.8334 29.2292 31.3334C28.7153 31.8334 28.1389 32.0834 27.5 32.0834L2.5 32.0834C1.83333 32.0834 1.25 31.8334 0.75 31.3334C0.25 30.8334 -8.01375e-08 30.25 -1.09278e-07 29.5834L-1.20206e-06 4.58338C-1.22999e-06 3.94449 0.249999 3.3681 0.749999 2.85421C1.25 2.34032 1.83333 2.08338 2.5 2.08338L27.5 2.08338C28.1389 2.08338 28.7153 2.34032 29.2292 2.85421C29.7431 3.3681 30 3.94449 30 4.58337L30 12.0834L35 17.0834ZM27.5 29.5834L27.5 21.0834L31.5 17.0834L27.5 13.0834L27.5 4.58337L2.5 4.58338L2.5 29.5834L27.5 29.5834ZM2.5 29.5834L27.5 29.5834L2.5 29.5834ZM17.4583 14.7084L15.125 9.37504L12.7917 14.7084L7.45833 17.0417L12.7917 19.4167L15.125 24.7084L17.4583 19.4167L22.7917 17.0417L17.4583 14.7084Z",
    fill: "#4B2B5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2378_6625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedMeditationIcon);
export default __webpack_public_path__ + "static/media/suggestedMeditationIcon.f6289dae1926d0f353b6341873c04c0f.svg";
export { ForwardRef as ReactComponent };